/* eslint-disable camelcase */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @stylistic/no-mixed-operators */
/* eslint-disable no-self-compare */
/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Row, Col, Table, Spinner } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

import Money from '../Parts/Money';
import ShadePriceBreakdown from '../Quote/NewOptionFields/ShadeActions/ShadePriceBreakdown';
import Button from '../Parts/Button';
import { useAssembliesByQuoteId, UseAssembly } from '../Store/entities/assemblies/hooks';
import {
	UseMultipliersByQuoteId,
	useQuoteById,
	useQuotePricing,
	useQuoteTypeNameByQuoteId
} from '../Store/entities/quotes/hooks';
import { useQuoteAccessories } from '../Store/entities/accessories/hooks';
import { useQuoteAwnings } from '../Store/entities/awnings/hooks';
import { useFullHWRItemsByQuoteId, useHWRItemsByQuoteId } from '../Store/entities/hardwareRequestItems/hooks';

import { useQuoteDemoReview } from '../Store/entities/quoteDemoReviews/hooks';
import apiCalls from '../PowerShadesAPIFunctions';
import { ZohoBooksInvoice } from '../powershadesApiTypeExtensions';
import { QuoteCouponExplanation } from '../powershadesApiTypes';
import { getAwningTierPrice } from '../Quote/awningConfiguratorUtils';

const ShadeCostRow = ({ quoteId, sequenceId, setShowingShade }:
{ quoteId: number, sequenceId: number, setShowingShade: () => void }) => {
	const shade = UseAssembly(quoteId, sequenceId);

	const multipliers = UseMultipliersByQuoteId(quoteId);

	const distMultiplier = multipliers?.list?.find((m) =>
		m.name.toLowerCase().includes('distributor'))?.multiplier ?? 0.425;
	const dealerMultiplier = multipliers?.list?.find((m) => m.name.toLowerCase().includes('dealer'))?.multiplier ?? 0.5;

	const distributor = (shade?.msrp ?? 0) * distMultiplier;
	const dealer = (shade?.msrp ?? 0) * dealerMultiplier;

	if (!shade) {
		return null;
	}

	const { shade_name, room_name, cost, msrp } = shade;
	return (
		<tr className={msrp === 0 ? 'error view-cost-row' : 'view-cost-row'}>
			<td>{room_name}</td>
			<td>
				<button
					type="button"
					onClick={() => {
						setShowingShade();
					}}
				>
					{shade_name}
				</button>
			</td>
			<td>
				<Money>{cost}</Money>
			</td>
			<td>
				<Money>{distributor}</Money>
			</td>
			<td>
				<Money>{dealer}</Money>
			</td>
			<td>
				<Money>{msrp}</Money>
			</td>
		</tr>
	);
};

const ShadesCostBreakdown = ({ quoteId, setSelectedSeqIdForShowing }) => {
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const prices: { access: string, label: string }[] = [
		{
			access: 'dealer',
			label: 'dealer',
		},
		{
			access: 'PSMSRP',
			label: 'price',
		},
		{
			access: 'distributor',
			label: 'distributor',
		},
		{
			access: 'cost',
			label: 'cost',
		},
	];

	const assemblies = useAssembliesByQuoteId(quoteId);
	const multipliers = UseMultipliersByQuoteId(quoteId);

	const distMultiplier = multipliers?.list?.find((m) =>
		m.name.toLowerCase().includes('distributor'))?.multiplier ?? 0.425;
	const dealerMultiplier = multipliers?.list?.find((m) => m.name.toLowerCase().includes('dealer'))?.multiplier ?? 0.5;

	// This parses through the MSRP's and grabs and allocates the prices
	const shadeSplit = assemblies.map((s) => ({
		room_name: s.room_name,
		shade_name: s.shade_name,
		sequence_id: s.sequence_id,
		cost: s.cost,
		distributor: s.msrp * distMultiplier,
		dealer: s.msrp * dealerMultiplier,
		msrp: s.msrp
	}));

	const totalAssemblyCost = prices.reduce((acc, price) => {
		if (!acc[price.label]) {
			acc[price.label] = 0;
		}

		shadeSplit.forEach((shade) => {
			acc[price.label] += shade[price.label];
		});

		return acc;
	}, {} as {
		cost: number;
		distributor: number;
		dealer: number;
		msrp: number;
	});

	const { distributor, dealer, msrp } = totalAssemblyCost;
	let { cost } = totalAssemblyCost;

	cost = shadeSplit.reduce((previousValue, shade) => previousValue + shade.cost, 0);

	const shadeRows = shadeSplit.map((shade) => (
		<ShadeCostRow
			quoteId={quoteId}
			sequenceId={shade.sequence_id}
			setShowingShade={() => {
				setSelectedSeqIdForShowing(shade.sequence_id);
			}}
		/>
	));

	return (
		<Table bordered hover size="sm" className={quoteType}>
			<tbody>
				<tr className="bold-row">
					<th colSpan={6}>Shades</th>
				</tr>

				<tr>
					<th>Room Name</th>
					<th>Shade Name</th>
					<th>Cost</th>
					<td>
						<strong>
							Dist. Sale Price (
							{distMultiplier}
							{' '}
							Multiplier)
						</strong>
					</td>
					<td>
						<strong>
							Dealer Sale Price (
							{dealerMultiplier}
							{' '}
							Multiplier)
						</strong>
					</td>
					<td>
						<strong>Price</strong>
					</td>
				</tr>

				{shadeRows}

				<tr>
					<td>Total:</td>
					<td aria-label="Empty cell" />
					<td>
						<strong>
							<Money>{cost}</Money>
						</strong>
					</td>
					<td>
						<strong>
							<Money>{distributor}</Money>
						</strong>
					</td>
					<td>
						<strong>
							<Money>{dealer}</Money>
						</strong>
					</td>
					<td>
						<strong>
							<Money>{msrp}</Money>
						</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	);
};

const AwningsCostBreakdown = ({ quoteId }: { quoteId: number }) => {
	const awnings = useQuoteAwnings(quoteId);
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	let totalCost = 0;
	let totalDistributor = 0;
	let totalDealer = 0;
	let totalMsrp = 0;

	const rows = awnings.map((awning) => {
		if (!awning) {
			return null;
		}

		const cost = getAwningTierPrice(awning, 'cost');
		const msrp = getAwningTierPrice(awning, 'msrp');
		const distributor = getAwningTierPrice(awning, 'distributor');
		const dealer = getAwningTierPrice(awning, 'dealer');

		totalCost += cost;
		totalDistributor += distributor;
		totalDealer += dealer;
		totalMsrp += msrp;

		const awningName = awning.shade_name || awning.name || 'Awning';

		// Awnings price asynchronously through the item queue, so a zeroed row may simply not have
		// its price yet. Show the spinner for that, and only flag an error once pricing has settled.
		const isPricing = Boolean(awning.is_pricing);
		const rowClass = msrp === 0 && !isPricing ? 'error view-cost-row' : 'view-cost-row';
		const priceCell = (value: number) => (
			isPricing ? <Spinner size="sm" animation="border" title="Pricing..." /> : <Money>{value}</Money>
		);

		return (
			<tr key={awning.line_number} className={rowClass}>
				<td>{awning.room_name}</td>
				<td>{awningName}</td>
				<td>{priceCell(cost)}</td>
				<td>{priceCell(distributor)}</td>
				<td>{priceCell(dealer)}</td>
				<td>{priceCell(msrp)}</td>
			</tr>
		);
	});

	return (
		<Table bordered hover size="sm" className={quoteType} key="awning-table">
			<tbody>
				<tr className="bold-row">
					<th colSpan={6}>Awnings</th>
				</tr>

				<tr>
					<th>Room Name</th>
					<th>Awning Name</th>
					<th>Cost</th>
					<th>Dist. Sale Price</th>
					<th>Dealer Sale Price</th>
					<th>Price</th>
				</tr>

				{rows}

				<tr>
					<td>Total:</td>
					<td aria-label="Empty cell" />
					<td>
						<b>
							<Money>{totalCost}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalDistributor}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalDealer}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalMsrp}</Money>
						</b>
					</td>
				</tr>
			</tbody>
		</Table>
	);
};

const AccessoriesCostBreakdown = ({ quoteId }) => {
	const quoteAccessories = useQuoteAccessories(quoteId);

	const mutlipliers = UseMultipliersByQuoteId(quoteId);
	const dealerMultiplier = mutlipliers?.list?.find((m) => m.name.toLowerCase().includes('dealer'))?.multiplier ?? 0.5;

	const distributorMultiplier = mutlipliers?.list
		?.find((m) => m.name.toLowerCase().includes('distributor'))?.multiplier ?? 0.425;

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const accessories = quoteAccessories.map((acc) => {
		if (!acc || (!acc?.cost && !acc?.name)) {
			return null;
		}

		return {
			...acc,
			name: acc?.name ?? acc?.name,
			total_cost: (acc?.cost ?? 0) * acc.quantity,
		};
	});

	let totalCost = 0;
	let totalDistributor = 0;
	let totalDealer = 0;
	let totalMsrp = 0;

	const rows = accessories.map((acc) => {
		if (!acc || acc.quantity === 0 || acc.quantity === 0) {
			return null;
		}

		const { cost, msrp } = acc;

		const distributor = msrp * distributorMultiplier;
		const dealer = msrp * dealerMultiplier;

		totalCost += cost;
		totalDistributor += distributor;
		totalDealer += dealer;
		totalMsrp += msrp;

		return (
			<tr key={acc.part_number}>
				<td>{acc.name}</td>
				<td>{acc.quantity}</td>
				<td>
					<Money>{cost}</Money>
				</td>
				<td>
					<Money>{distributor}</Money>
				</td>
				<td>
					<Money>{dealer}</Money>
				</td>
				<td>
					<Money>{msrp}</Money>
				</td>
			</tr>
		);
	});

	return (
		<Table bordered hover size="sm" className={quoteType}>
			<tbody>
				<tr className="bold-row">
					<th colSpan={6}>Accessories</th>
				</tr>

				<tr>
					<th>Name</th>
					<th>Quantity</th>
					<th>Cost</th>
					<th>
						Dist. Sale Price (
						{distributorMultiplier}
						{' '}
						Multiplier)
					</th>
					<th>
						Dealer Sale Price (
						{dealerMultiplier}
						{' '}
						Multiplier)
					</th>
					<th>Price</th>
				</tr>

				{rows}

				<tr>
					<td>Total:</td>
					<td aria-label="Empty cell" />
					<td>
						<b>
							<Money>{totalCost}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalDistributor}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalDealer}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalMsrp}</Money>
						</b>
					</td>
				</tr>
			</tbody>
		</Table>
	);
};

const HardwareCostBreakdown = ({ quoteId }: { quoteId: number }) => {
	const hwItems = useHWRItemsByQuoteId(quoteId);
	const fullHwItems = useFullHWRItemsByQuoteId(quoteId);

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	let totalCost = 0;
	let totalDistributor = 0;
	let totalDealer = 0;
	let totalMsrp = 0;

	const multipliers = UseMultipliersByQuoteId(quoteId);

	const distMultiplier = multipliers?.list?.find((m) =>
		m.name.toLowerCase().includes('distributor'))?.multiplier ?? 0.425;
	const dealerMultiplier = multipliers?.list?.find((m) => m.name.toLowerCase().includes('dealer'))?.multiplier ?? 0.5;

	const rows = hwItems.map((item) => {
		if (!item || item.quantity === 0) {
			return null;
		}

		const { cost } = item;
		const { msrp } = item;

		const dealer = msrp * dealerMultiplier;
		const distributor = msrp * distMultiplier;

		const partTotalCost = cost * item.quantity;
		const partTotalDistributor = distributor * item.quantity;
		const partTotalDealer = dealer * item.quantity;
		const partTotalMsrp = msrp * item.quantity;

		totalCost += partTotalCost;
		totalDistributor += partTotalDistributor;
		totalDealer += partTotalDealer;
		totalMsrp += partTotalMsrp;

		const baseItem = fullHwItems.find((hw) => hw.partNumber === item.part_number);

		return (
			<tr key={`${item.part_number}-${item.line_number}`}>
				<td>{item.part_number}</td>
				<td>
					{item.quantity}
					{' '}
					{baseItem?.uom}
				</td>
				<td>
					<Money>{partTotalCost}</Money>
				</td>
				<td>
					<Money>{partTotalDistributor}</Money>
				</td>
				<td>
					<Money>{partTotalDealer}</Money>
				</td>
				<td>
					<Money>{partTotalMsrp}</Money>
				</td>
			</tr>
		);
	});

	return (
		<Table bordered hover size="sm" className={quoteType}>
			<tbody>
				<tr className="bold-row">
					<th colSpan={6}>Hardware Requests</th>
				</tr>

				<tr>
					<th>Name</th>
					<th>Quantity</th>
					<th>Cost</th>
					<th>
						Dist. Price (
						{distMultiplier}
						{' '}
						Multiplier)
					</th>
					<th>
						Dealer Price (
						{dealerMultiplier}
						{' '}
						Multiplier)
					</th>
					<th>Price</th>
				</tr>

				{rows}

				<tr>
					<td>Total:</td>
					<td aria-label="Empty cell" />
					<td>
						<b>
							<Money>{totalCost}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalDistributor}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalDealer}</Money>
						</b>
					</td>
					<td>
						<b>
							<Money>{totalMsrp}</Money>
						</b>
					</td>
				</tr>
			</tbody>
		</Table>
	);
};

const TaxCostBreakdown = ({ quoteId }: { quoteId: number }) => {
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const mutlipliers = UseMultipliersByQuoteId(quoteId);
	const dealerMultiplier = mutlipliers?.list?.find((m) => m.name.toLowerCase().includes('dealer'))?.multiplier ?? 0.5;
	const distributorMultiplier = mutlipliers?.list
		?.find((m) => m.name.toLowerCase().includes('distributor'))?.multiplier ?? 0.425;

	const dealerQuotePricing = useQuotePricing(quoteId, dealerMultiplier);
	const distributorQuotePricing = useQuotePricing(quoteId, distributorMultiplier);
	const msrpQuotePricing = useQuotePricing(quoteId, 1);

	const salesTax = useQuoteById(quoteId).sales_tax_percentage_snapshot ?? 0;
	const costTaxSnapsot = 0;
	return (
		<Table key="tax-table" bordered hover size="sm" className={quoteType}>
			<tbody>
				<tr className="bold-row">
					<th colSpan={6}>Taxes</th>
				</tr>

				<tr>
					<th>Name</th>
					<th>Percentage</th>
					<th>Cost</th>
					<th>
						Dist. Price (
						{distributorMultiplier}
						{' '}
						Multiplier)
					</th>
					<th>
						Dealer Price (
						{dealerMultiplier}
						{' '}
						Multiplier)
					</th>
					<th>Price</th>
				</tr>

				<tr>
					<td>Quote Taxes</td>
					<td>{salesTax}</td>
					<td>
						<strong>
							<Money>{costTaxSnapsot}</Money>
						</strong>
					</td>
					<td>
						<strong>
							<Money>{distributorQuotePricing?.total_taxes}</Money>
						</strong>
					</td>
					<td>
						<strong>
							<Money>{dealerQuotePricing?.total_taxes}</Money>
						</strong>
					</td>
					<td>
						<strong>
							<Money>{msrpQuotePricing?.total_taxes}</Money>
						</strong>
					</td>
				</tr>
			</tbody>
		</Table>
	);
};

const ShippingCostBreakdown = ({ quoteId }: { quoteId: number }) => {
	const totals = useQuotePricing(quoteId, 1);
	const parcel = totals?.parcel_shipping_price ?? 0;
	const oversized = totals?.freight_shipping_price ?? 0;
	const totalShipping = parcel + oversized;

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const shadeAssemblies = useAssembliesByQuoteId(quoteId);
	const awnings = useQuoteAwnings(quoteId);

	return (
		<Table bordered hover size="sm" className={quoteType} key="shippingcost-table">
			<tbody>
				<tr className="bold-row">
					<th colSpan={6}>Shipping</th>
				</tr>
				<tr>
					<th>Name</th>
					<th>Cost</th>
					<th>Dist. Price</th>
					<th>Dealer Price</th>
					<th>Price</th>
				</tr>
				<tr>
					<td>Parcel Shipping</td>
					<td>
						<Money>{parcel}</Money>
					</td>
					<td>
						<Money>{parcel}</Money>
					</td>
					<td>
						<Money>{parcel}</Money>
					</td>
					<td>
						<Money>{parcel}</Money>
					</td>
				</tr>
				<tr>
					<td>Freight Shipping</td>
					<td>
						<Money>{oversized}</Money>
					</td>
					<td>
						<Money>{oversized}</Money>
					</td>
					<td>
						<Money>{oversized}</Money>
					</td>
					<td>
						<Money>{oversized}</Money>
					</td>
				</tr>
				{shadeAssemblies.length > 0 || awnings.length > 0 ? (
					<tr>
						<td>Total:</td>

						<td>
							<b>
								<Money>{totalShipping}</Money>
							</b>
						</td>
						<td>
							<b>
								<Money>{totalShipping}</Money>
							</b>
						</td>
						<td>
							<b>
								<Money>{totalShipping}</Money>
							</b>
						</td>
						<td>
							<b>
								<Money>{totalShipping}</Money>
							</b>
						</td>
					</tr>
				) : null}
			</tbody>
		</Table>
	);
};

const TotalsCostBreakdown = ({ quoteId, setViewState }: {
	quoteId: number;
	setViewState: React.Dispatch<React.SetStateAction<"cost_breakdown" | "invoice" | "coupon">>;
}) => {
	const assemblies = useAssembliesByQuoteId(quoteId);
	const quoteAccessories = useQuoteAccessories(quoteId);
	const awnings = useQuoteAwnings(quoteId);
	const quote = useQuoteById(quoteId);
	const hwItems = useHWRItemsByQuoteId(quoteId);

	const mult = UseMultipliersByQuoteId(quoteId);
	const distM = mult?.list?.find((m) => m.name.toLowerCase().includes('distributor'))?.multiplier ?? 0.5;
	const dealerM = mult?.list?.find((m) => m.name.toLowerCase().includes('dealer'))?.multiplier ?? 0.5;

	const distributorPricing = useQuotePricing(quoteId, distM);
	const dealerPricing = useQuotePricing(quoteId, dealerM);
	const msrpPricing = useQuotePricing(quoteId, 1);

	const hwLineItems = useHWRItemsByQuoteId(quoteId);

	const demoInfo = useQuoteDemoReview(quoteId);

	let newMsrp = (demoInfo?.name !== 'cash'
		? (msrpPricing?.total_price ?? 0) * (1 - (demoInfo?.value ?? 0) / 100)
		: (demoInfo?.value ?? 0));

	newMsrp += msrpPricing?.total_shipping_price ?? 0;

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	// Hardware Request Items cost,dealer price, distributor price, msrp totals, and shipping totals
	const hardwareCostTotal = hwLineItems.reduce((acc, item) => {
		const hwItem = hwItems.find((hw) => hw.line_number === item.line_number);
		return acc + (item.cost * (hwItem?.quantity ?? 0));
	}, 0);

	const hardwareDealerTotal = hwLineItems.reduce((acc, item) => {
		const hwItem = hwItems.find((hw) => hw.line_number === item.line_number);
		return acc + (item.msrp * dealerM * (hwItem?.quantity ?? 0));
	}, 0);

	const hardwareDistributorTotal = hwLineItems.reduce((acc, item) => {
		const hwItem = hwItems.find((hw) => hw.line_number === item.line_number);
		return acc + (item.msrp * distM * (hwItem?.quantity ?? 0));
	}, 0);

	const hardwareMsrpTotal = hwLineItems.reduce((acc, item) => {
		const hwItem = hwItems.find((hw) => hw.line_number === item.line_number);
		return acc + (item.msrp * (hwItem?.quantity ?? 0));
	}, 0);

	// Assembly cost,dealer price, distributor price, msrp totals, and shipping totals
	const assemblyCostTotal = assemblies.reduce((acc, assembly) => acc + (assembly.cost), 0);

	const assemblyDistributorTotal = assemblies.reduce((acc, assembly) => acc + (assembly.msrp * distM), 0);

	const assemblyDealerTotal = assemblies.reduce((acc, assembly) => acc + (assembly.msrp * dealerM), 0);

	const assemblyMsrpTotal = assemblies.reduce((acc, assembly) => acc + (assembly.msrp), 0);

	// Awning cost,dealer price, distributor price, msrp totals, and shipping totals
	const awningCostTotal = awnings.reduce((acc, awning) => acc + getAwningTierPrice(awning, 'cost'), 0);

	const awningDistributorTotal = awnings.reduce((acc, awning) => acc + getAwningTierPrice(awning, 'distributor'), 0);

	const awningDealerTotal = awnings.reduce((acc, awning) => acc + getAwningTierPrice(awning, 'dealer'), 0);

	const awningMsrpTotal = awnings.reduce((acc, awning) => acc + getAwningTierPrice(awning, 'msrp'), 0);

	// Any awning still in the pricing queue makes the awning totals incomplete, so show the same
	// spinner the individual rows show rather than a subtotal that is about to change.
	const awningsArePricing = awnings.some((awning) => awning.is_pricing);

	// Accessory cost,dealer price, distributor price, msrp totals, and shipping totals
	const accessoryCostTotal = quoteAccessories?.reduce((acc, accessory) => acc + (accessory.cost), 0);

	const accessoryDistributorTotal = quoteAccessories?.reduce((acc, accessory) => acc + (accessory.msrp * distM), 0);

	const accessoryDealerTotal = quoteAccessories?.reduce((acc, accessory) => acc + (accessory.msrp * dealerM), 0);

	const accessoryMsrpTotal = quoteAccessories?.reduce((acc, accessory) => acc + (accessory.msrp), 0);

	const quoteShippingTotal = msrpPricing?.total_shipping_price ?? 0;

	// Totals, always final toal at end, if there is assemblies,
	// accessories, or hardware requests then their totals will be here aswell.
	const msrpPrice = (quote.msrp_sale_price_snapshot ?? 0);
	const msrpTaxes = quote.sales_tax_percentage_snapshot * msrpPrice;

	const taxCostTotal = 0;

	const isDemo = quote?.quote_type_id === 6;
	const hasDiscount = quote.coupon_snapshot ?? 0 > 0;

	const assumedDealerPrice = assemblyDealerTotal + accessoryDealerTotal + hardwareDealerTotal + awningDealerTotal;
	const hasDistributor = distM !== dealerM;

	let dealerSavings = isDemo ? (assumedDealerPrice - newMsrp) : (dealerPricing?.coupon_total ?? 0);
	const distributorDemoSavings = isDemo ? (assumedDealerPrice - newMsrp) : (distributorPricing?.coupon_total ?? 0);

	if (hasDistributor && !isDemo) {
		dealerSavings = distributorDemoSavings * (dealerM / distM);
	}

	const dealerDemoSavings = dealerSavings;
	const msrpDemoSavings = dealerDemoSavings * (1 / dealerM);

	const discountType = isDemo ? "Demo Reduction" : "Discount";

	const costTotal = quote.cost_snapshot ?? 0;
	const dealerTotal = (quote.dealer_sale_price_snapshot ?? 0);
	const distributorTotal = (quote.dist_sale_price_snapshot ?? 0);
	const msrpTotal = (quote.msrp_sale_price_snapshot ?? 0);

	return (<Table key="tax-table" bordered hover size="sm" className={quoteType}>
		<tbody>
			<tr className="bold-row">
				<th colSpan={6}>Totals</th>
			</tr>

			<tr>
				<th>Name</th>
				<th>Cost</th>
				{hasDistributor && <th>
					Dist. Price (
					{distM}
					{' '}
					Multiplier)
				</th>}
				<th>
					Dealer Price (
					{dealerM}
					{' '}
					Multiplier)
				</th>
				<th>Price</th>
			</tr>
			{assemblyCostTotal > 0 && <tr>
				<td>Assemblies</td>
				<td>
					<Money>{assemblyCostTotal}</Money>
				</td>
				{hasDistributor && <td>
					<Money>{assemblyDistributorTotal}</Money>
				</td>}
				<td>
					<Money>{assemblyDealerTotal}</Money>
				</td>
				<td>
					<Money>{assemblyMsrpTotal}</Money>
				</td>
			</tr>}
			{(awningMsrpTotal > 0 || awningsArePricing) && <tr>
				<td>Awnings</td>
				<td>
					{awningsArePricing ? <Spinner size="sm" animation="border" title="Pricing..." /> : <Money>{awningCostTotal}</Money>}
				</td>
				{hasDistributor && <td>
					{awningsArePricing ? <Spinner size="sm" animation="border" title="Pricing..." /> : <Money>{awningDistributorTotal}</Money>}
				</td>}
				<td>
					{awningsArePricing ? <Spinner size="sm" animation="border" title="Pricing..." /> : <Money>{awningDealerTotal}</Money>}
				</td>
				<td>
					{awningsArePricing ? <Spinner size="sm" animation="border" title="Pricing..." /> : <Money>{awningMsrpTotal}</Money>}
				</td>
			</tr>}
			{
				accessoryCostTotal > 0 && <tr>
					<td>Accessories</td>
					<td>
						<Money>{accessoryCostTotal}</Money>
					</td>
					{hasDistributor && <td>
						<Money>{accessoryDistributorTotal}</Money>
					</td>}
					<td>
						<Money>{accessoryDealerTotal}</Money>
					</td>
					<td>
						<Money>{accessoryMsrpTotal}</Money>
					</td>
				</tr>
			}
			{
				hardwareCostTotal > 0 && <tr>
					<td>Hardware Requests</td>
					<td>
						<Money>{hardwareCostTotal}</Money>
					</td>
					{hasDistributor && <td>
						<Money>{hardwareDistributorTotal}</Money>
					</td>}
					<td>
						<Money>{hardwareDealerTotal}</Money>
					</td>
					<td>
						<Money>{hardwareMsrpTotal}</Money>
					</td>
				</tr>
			}
			{
				quoteShippingTotal > 0 && <tr>
					<td>Shipping</td>
					<td>
						<Money>{quoteShippingTotal}</Money>
					</td>
					{hasDistributor && <td>
						<Money>{quoteShippingTotal}</Money>
					</td>}
					<td>
						<Money>{quoteShippingTotal}</Money>
					</td>
					<td>
						<Money>{quoteShippingTotal}</Money>
					</td>
				</tr>
			}
			{
				msrpTaxes > 0 && <tr>
					<td>Taxes</td>
					<td>
						<Money>{taxCostTotal}</Money>
					</td>
					{hasDistributor && <td>
						<Money>{distributorPricing?.total_taxes}</Money>
					</td>}
					<td>
						<Money>{dealerPricing?.total_taxes}</Money>
					</td>
					<td>
						<Money>{msrpPricing?.total_taxes}</Money>
					</td>
				</tr>
			}
			{(isDemo || hasDiscount) ? <tr>
				<td
					onClick={() => {
						setViewState("coupon");
					}}
				>
					{discountType}
				</td>
				<td>
					<strong>
						<Money>{0}</Money>
					</strong>
				</td>
				{hasDistributor && <td>
					<strong>
						<Money>{-distributorDemoSavings}</Money>
					</strong>
				</td>}
				<td>
					<strong>
						<Money>{-dealerDemoSavings}</Money>
					</strong>
				</td>
				<td>
					<strong>
						<Money>{-msrpDemoSavings}</Money>
					</strong>
				</td>
			</tr> : null}
			<tr>
				<td>Quote Totals</td>
				<td>
					<strong>
						<Money>{costTotal}</Money>
					</strong>
				</td>
				{hasDistributor && <td>
					<strong>
						<Money>{distributorTotal}</Money>
					</strong>
				</td>}
				<td>
					<strong>
						<Money>{dealerTotal}</Money>
					</strong>
				</td>
				<td>
					<strong>
						<Money>{msrpTotal}</Money>
					</strong>
				</td>
			</tr>
		</tbody>
	</Table>
	);
};

const InvoiceCostBreakdown = ({ invoiceData, quoteId, setViewState, isLoading }: {
	invoiceData: ZohoBooksInvoice | null;
	quoteId: number;
	setViewState: React.Dispatch<React.SetStateAction<"cost_breakdown" | "invoice" | "coupon">>;
	isLoading: boolean;
}) => {
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	if (!invoiceData) {
		return <div className="modal-holder local-bootstrap">
			<div className="quote-history-modal">
				<Container>
					<Row className="mb-2">
						<Col>
							<h4 className={`text-${quoteType}`}>Loading Invoice...</h4>
						</Col>
						<Col>
							<Button color={quoteType} onClick={() => setViewState('cost_breakdown')}>
								View Cost Breakdown
							</Button>
						</Col>
					</Row>
				</Container>
			</div>
		</div>;
	}

	const lineItemTotal = invoiceData?.line_items?.reduce((acc, item) => acc + (item.rate ?? 0), 0) ?? 0;
	const taxTotal = lineItemTotal * Number(invoiceData?.tax_rate ?? 0);

	const finalTotal = lineItemTotal
		+ (Number(invoiceData?.shipping_charge ?? 0))
		+ (taxTotal ?? 0)
		+ (Number(invoiceData?.adjustment ?? 0));

	return (
		<div className="modal-holder local-bootstrap">
			<div className="quote-history-modal">
				<Container>
					<Row className="mb-2">
						<Col>
							<h4 className={`text-${quoteType}`}>Projected Invoice Snapshot</h4>
						</Col>
						<Col className="text-right">
							<Button color={quoteType} onClick={() => setViewState('cost_breakdown')}>
								{`View Cost Breakdown ${isLoading ? 'Loading...' : ''}`}
							</Button>
						</Col>
					</Row>
					<Row>
						<Col>
							<Row>
								<Col>
									<h5 className={`text-${quoteType}`}>Invoice Contact:</h5>
								</Col>
								<Col>
									<p className={`text-${quoteType}`}>
										{invoiceData.customer_name}
									</p>
								</Col>
							</Row>
							<Row>
								{/* Invoice Address Broken Out */}
								<Col>
									<Row>
										<Col>
											Address:
										</Col>
										<Col>
											<p>
												{invoiceData?.shipping_address?.address}
											</p>
											<p>
												{invoiceData?.shipping_address?.street2}
											</p>
										</Col>
									</Row>
									<Row>
										<Col>
											City:
										</Col>
										<Col>
											<p >
												{invoiceData?.shipping_address?.city}
											</p>
										</Col>
									</Row>

									<Row>
										<Col>
											State:
										</Col>
										<Col>
											<p >
												{invoiceData?.shipping_address?.state}
											</p>
										</Col>
									</Row>
									<Row>
										<Col>
											Zip Code:
										</Col>
										<Col>
											<p>
												{invoiceData?.shipping_address?.zip}
											</p>
										</Col>
									</Row>
									<Row>
										<Col>
											Country:
										</Col>
										<Col>
											<p>
												{invoiceData?.shipping_address?.country}
											</p>
										</Col>
									</Row>
									<Row>
										<Col>
											Phone:
										</Col>
										<Col>
											<p>
												{invoiceData?.shipping_address?.phone}
											</p>
										</Col>
									</Row>
								</Col>
							</Row>
						</Col>
						<Col>
							<Row>
								<Col>
									<h5 className={`text-${quoteType}`}>Invoice Number:</h5>
								</Col>
								<Col>
									<h5 className={`text-${quoteType}`}>
										{`INV-${quoteId}`}
									</h5>
								</Col>
							</Row>
							<Row>
								<Col>
									<h5 className={`text-${quoteType}`}>Invoice Date:</h5>
								</Col>
								<Col>
									<p>
										{invoiceData.date}
									</p>
								</Col>
							</Row>
							<Row>
								<Col>
									<h5 className={`text-${quoteType}`}>Invoice Terms:</h5>
								</Col>
								<Col>
									<p >
										{invoiceData.payment_terms}
									</p>
								</Col>
							</Row>
							<Row>
								<Col>
									<h5 className={`text-${quoteType}`}>Invoice Due Date:</h5>
								</Col>
								<Col>
									<p>
										{invoiceData.due_date}
									</p>
								</Col>
							</Row>
							<Row>
								<Col>
									<h5 className={`text-${quoteType}`}>Invoice Sidemark:</h5>
								</Col>
								<Col>
									<p>
										{invoiceData.reference_number}
									</p>
								</Col>
							</Row>

						</Col>
					</Row>
					<Row>
						{/* Invoice Line Items */}
						<Col>
							<Table bordered hover size="sm" className={quoteType}>
								<thead>
									<tr>
										<th>Item Name</th>
										<th>Amount</th>
									</tr>
								</thead>
								<tbody>
									{invoiceData.line_items.map((item) => (
										<tr key={item.item_id}>
											<td>{item.name}</td>
											<td><Money>{item.rate}</Money></td>
										</tr>
									))}
								</tbody>
							</Table>
						</Col>
					</Row>
					{/* Invoice Totals
									Subtotal, Taxes, Shipping, Discounts, Total
								*/}
					<Row>
						<Col>
							<Table bordered hover size="sm" className={quoteType}>
								<tbody>
									<tr>
										<td>Subtotal</td>
										<td><Money>{lineItemTotal}</Money></td>
									</tr>
									<tr>
										<td>
											Tax Rate (
											{invoiceData.tax_rate}
											%)
										</td>
										<td><Money>{taxTotal}</Money></td>
									</tr>
									<tr>
										<td>Shipping</td>
										<td><Money>{invoiceData.shipping_charge}</Money></td>
									</tr>
									<tr>
										<td>
											Discounts (
											{invoiceData.adjustment_description}
											)
										</td>
										<td><Money>{invoiceData.adjustment}</Money></td>
									</tr>
									<tr className="bold-row">
										<td>Total</td>
										<td><Money>{finalTotal}</Money></td>
									</tr>
								</tbody>
							</Table>
						</Col>

					</Row>
				</Container>
			</div>
		</div>
	);
};

const CouponBreakdown = ({ quoteId, done }: { quoteId: number, done: () => void }) => {
	const [couponExplanation, setCouponExplanation] = useState<QuoteCouponExplanation>();

	useEffect(() => {
		apiCalls.getQuoteCouponExplanation(quoteId).then((c) => {
			setCouponExplanation(c.data);
		});
	}, []);

	const {
		coupon_name,
		coupon_type,
		dealer_discount,
		distributor_discount,
		formula_string,
		interpolated_formula_string
	} = couponExplanation ?? {
		coupon_name: "",
		coupon_type: "",
		dealer_discount: 0,
		distributor_discount: 0,
		formula_string: "",
		interpolated_formula_string: ""
	};

	const formatSnakeCase = (str: string | undefined) => {
		if (!str) return '';
		return str.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
	};

	const formatFormula = (str: string | undefined) => {
		if (!str) return '';
		return str
			.replace(/([a-z])([A-Z])/g, '$1 $2')
			.replace(/\b\w/g, (l) => l.toUpperCase());
	};

	return (
		<div className="modal-holder local-bootstrap">
			<div className="quote-history-modal">
				<Container>
					<Row className="mb-3 align-items-center">
						<Col xs={2}>
							<Button color="transparent" onClick={done} className='border-0 p-2'>
								<FontAwesomeIcon icon={faArrowLeft} color='gray' onClick={done} />
							</Button>
						</Col>
						<Col xs={8}>
							<h3 className="m-0 text-center">Coupon Explanation</h3>
							<div className="text-muted text-center small">Shipping is excluded from calculations</div>
						</Col>
						<Col xs={2} />
					</Row>

					<div className="p-3 border rounded mb-3 bg-light">
						<Row className="mb-2">
							<Col sm={3} className="fw-bold">Coupon Name:</Col>
							<Col>{coupon_name}</Col>
						</Row>
						<Row>
							<Col sm={3} className="fw-bold">Type:</Col>
							<Col>{formatSnakeCase(coupon_type)}</Col>
						</Row>
					</div>

					<h5 className="mt-4 mb-3">Discounts</h5>
					<Table bordered hover size="sm">
						<thead>
							<tr>
								<th>Party</th>
								<th>Discount Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Dealer</td>
								<td><Money>{dealer_discount}</Money></td>
							</tr>
							<tr>
								<td>Distributor</td>
								<td><Money>{distributor_discount}</Money></td>
							</tr>
						</tbody>
					</Table>

					<h5 className="mt-4 mb-3">Calculation Details</h5>
					<div
						className="p-3 border rounded font-monospace bg-white"
						style={{ fontSize: '0.9em', overflowX: 'auto' }}
					>
						<div className="mb-2">
							<strong>Formula:</strong>
							<br />
							{formatFormula(formula_string)}
						</div>
						<hr />
						<div>
							<strong>Applied:</strong>
							<br />
							{interpolated_formula_string}
						</div>
					</div>
				</Container>
			</div>
		</div>
	);
};

const QuoteCostBreakdown = ({ quoteId, onClose }) => {
	const quote = useQuoteById(quoteId);
	const [viewState, setViewState] = useState<'cost_breakdown' | 'invoice' | 'coupon'>('cost_breakdown');

	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	const assemblies = useAssembliesByQuoteId(quoteId);
	const accessorries = useQuoteAccessories(quoteId);
	const awnings = useQuoteAwnings(quoteId);
	const hwItems = useHWRItemsByQuoteId(quoteId);
	const msrpPricing = useQuotePricing(quoteId, 1);
	const [isInvoiceLoading, setIsInvoiceLoading] = useState(false);
	const [invoiceData, setInvoiceData] = useState<ZohoBooksInvoice | null>(null);

	useEffect(() => {
		if (!isInvoiceLoading) {
			setIsInvoiceLoading(true);
			apiCalls.getQuoteInvoiceSnapshot(quoteId).then((resp) => {
				setInvoiceData(resp.data.invoice);
			}).finally(() => {
				setIsInvoiceLoading(false);
			});
		}
		// Fetch invoice data if needed
	}, [quoteId, assemblies.length, accessorries.length, awnings.length, hwItems.length]);

	const isAwningQuote = (quote?.product_category ?? 'roller_shades') === 'awnings';

	const hasAwnings = awnings.length > 0;
	const hasAccessories = accessorries.length > 0;
	const hasShades = assemblies.length > 0;
	const hasHardware = !!(hwItems.length > 0 && quoteType !== 'CEDIA');
	const hasTaxes = (quote.sales_tax_snapshot ?? 0) > 0 || (msrpPricing?.total_taxes ?? 0) > 0;
	const hasShipping = (quote.shipping_snapshot ?? 0) > 0 || (msrpPricing?.total_shipping_price ?? 0) > 0;
	const isDemo = quote?.quote_type_id === 6;
	const hasDiscount = (quote.coupon_snapshot ?? 0) > 0;
	const showCouponButton = isDemo || hasDiscount;

	const [selectedSeqIdForShowqing, setSelectedSeqIdForShowing] = useState<number>(0);
	const closeShadeBreakdown = () => {
		setSelectedSeqIdForShowing(0);
	};

	const isOpen = selectedSeqIdForShowqing !== 0;

	return (
		viewState === "coupon"
			? (
				<CouponBreakdown
					quoteId={quoteId}
					done={() => setViewState("cost_breakdown")}
				/>
			) : viewState === "cost_breakdown"
				? (
					isOpen

						? <ShadePriceBreakdown
							sequenceId={selectedSeqIdForShowqing}
							open={isOpen}
							quoteId={quoteId}
							// Old Object
							done={() => {
								closeShadeBreakdown();
							}}
							close={() => {
								closeShadeBreakdown();
							}}
						/>
						: <div key="cost_breakdown" className="modal-holder local-bootstrap">
							<div className="quote-history-modal">
								<Container>
									<Row className="mb-2">
										<Col>
											<h4 className={`text-${quoteType}`}>Cost Breakdown</h4>
										</Col>
										<Col className="d-flex justify-content-end">
											<Button color={quoteType} onClick={() => setViewState('invoice')}>
												View Projected Invoice
											</Button>
										</Col>
										{showCouponButton && (
											<Col className="d-flex justify-content-end">
												<Button color={quoteType} onClick={() => setViewState('coupon')}>
													View Coupon Explanation
												</Button>
											</Col>
										)}
									</Row>
									{isAwningQuote ? (
										hasAwnings ? (
											<Row>
												<Col>
													<AwningsCostBreakdown
														quoteId={quoteId}
													/>
												</Col>
											</Row>
										) : (
											<h6 className={`text-${quoteType} text-center mt-3 mb-3`}>
												No Awnings Found On Quote
											</h6>
										)
									) : (
										<>
											{hasShades ? (
												<Row>
													<Col>
														<ShadesCostBreakdown
															quoteId={quoteId}
															setSelectedSeqIdForShowing={setSelectedSeqIdForShowing}
														/>
													</Col>
												</Row>
											) : (
												<h6 className={`text-${quoteType} text-center mt-3 mb-3`}>
													No Shades Found On Quote
												</h6>
											)}
											{hasAccessories ? (
												<Row>
													<Col>
														<AccessoriesCostBreakdown
															quoteId={quoteId}
														/>
													</Col>
												</Row>
											) : (
												<h6 className={`text-${quoteType} text-center mt-3 mb-3`}>
													No Accessories Found On Quote
												</h6>
											)}
											{hasHardware ? (
												<Row>
													<Col>
														<HardwareCostBreakdown
															quoteId={quoteId}
														/>
													</Col>
												</Row>
											) : (
												<h6 className={`text-${quoteType} text-center mt-3 mb-3`}>
													No Hardware Found On Quote
												</h6>
											)}
										</>
									)}
									{hasTaxes ? (
										<Row>
											<Col>
												<TaxCostBreakdown
													quoteId={quoteId}
												/>
											</Col>
										</Row>
									) : (
										<h6 className={`text-${quoteType} text-center mt-3 mb-3`}>
											No Taxes Found On Quote
										</h6>
									)}
									{hasShipping ? (
										<Row>
											<Col>
												<ShippingCostBreakdown
													quoteId={quoteId}
												/>
											</Col>
										</Row>
									) : (
										<h6 className={`text-${quoteType} text-center mt-3 mb-3`}>
											No Shipping Found On Quote
										</h6>
									)}
									<Row>
										<TotalsCostBreakdown
											quoteId={quoteId}
											setViewState={setViewState}
										/>

									</Row>
									<Row className="pb-4">
										<Col>
											<Button color={quoteType} onClick={onClose}>
												Done
											</Button>
										</Col>
									</Row>
								</Container>
							</div>
						</div>
				)
				: (
					<InvoiceCostBreakdown
						key={`invoice-cost-breakdown-${quoteId}`}
						quoteId={quoteId}
						setViewState={setViewState}
						invoiceData={invoiceData}
						isLoading={isInvoiceLoading}
					/>

				)
	);
};

export default QuoteCostBreakdown;
